export default "__VITE_PUBLIC_ASSET__29cccbd4__"